const CoreFeatureFlags = {};
export default CoreFeatureFlags;
